import { motion } from "framer-motion";

import RyanAvatar from "../../images/ryan-avatar.png";

import { useBookMeetingModalTest } from "../../hooks/useBookMeetingModalTest";

export const BookButtonTest = () => {
  const { onOpen } = useBookMeetingModalTest();

  return (
    <motion.button
      initial="hidden"
      animate="visible"
      variants={{
        visible: {
          transition: {
            staggerChildren: 0.2,
          },
        },
      }}
      onClick={onOpen}
      className="book-button"
    >
      <motion.p
        variants={{
          hidden: { x: 50, opacity: 0 },
          visible: { x: 0, opacity: 1 },
        }}
        transition={{ duration: 0.3, delay: 0.6 }}
      >
        Book a time with Ryan
      </motion.p>
      <motion.img
        variants={{
          hidden: { y: 50, opacity: 0 },
          visible: { y: 0, opacity: 1 },
        }}
        transition={{ duration: 0.3 }}
        src={RyanAvatar}
        alt="Ryan Avatar"
      />
    </motion.button>
  );
};
